import './PriceLead.css';
import { useEffect, useState } from 'react';
import { refreshToken, getUserProfile, getLeadCardApproved, getLeadCardNotes, saveLeadCardNote, checkHasPaymentMethod, getCompanyOffer, createCompanyOffer, updateCompanyOffer, removeCompanyOffer } from '../../utils/api';
import { Helmet } from "react-helmet";
import { Routes, Route, Link, Outlet, useNavigate, useParams } from 'react-router-dom';
import iconCompanyDefault from '../../assets/companylogos/default.png';
import * as FaIcons from 'react-icons/fa';

const IconDisplay = ({ iconName }) => {
  // Dynamically get the icon component from the FaIcons object
  const IconComponent = FaIcons[iconName];

  // If the icon is found, render it
  if (IconComponent) {
    return <IconComponent />;
  }

  // Fallback if icon is not found
  return <p>Icon not found</p>;
};

const Offers = () => {
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const [data, setData] = useState(null);
  const [notes, setNotes] = useState([]);
  const [notesLoaded, setNotesLoaded] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);
  const [offerId, setOfferId] = useState("");
  const [offerTitle, setOfferTitle] = useState("");
  const [offerDescription, setOfferDescription] = useState("");
  const [offerType, setOfferType] = useState("discount");
  const [offerValue, setOfferValue] = useState("");
  const [offerCode, setOfferCode] = useState("");
  const [offerUrl, setOfferUrl] = useState("");
  const [offerExpiry, setOfferExpiry] = useState("");
  const [offerTerms, setOfferTerms] = useState("");
  const [hasOffer, setHasOffer] = useState(false);
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);
  const [loading, setLoading] = useState(true); // Make sure loading starts as true
  const [howToRedeem, setHowToRedeem] = useState("");
  let { id } = useParams();
  const navigate = useNavigate();


  const fetchOfferData = async () => {
    try {
      let res = await getCompanyOffer();
      if (res.success && res.data != null && res.data.length > 0) {
        let row = res.data[0];
        setOfferId(row.company_offer_id || "");
        setOfferTitle(row.title || "");
        setOfferDescription(row.description || "");
        setOfferType(row.offer_type || "discount");
        setOfferValue(row.offer_value || "");
        setOfferCode(row.offer_code || "");
        setOfferUrl(row.offer_url || "");
        setOfferExpiry(row.expires_on || "");
        setOfferTerms(row.terms_and_conditions || "");
        setHowToRedeem(row.how_to_redeem || "");
        setHasOffer(true);
      }
    } catch (error) {
      console.error("Error fetching offer data:", error);
    }
  }

  const handleSubmitOffer = async (e) => {
    e.preventDefault();
    // Handle form submission
    if (offerTitle === "" || offerDescription === "") {
      alert("Please fill in all required fields.");
      return;
    }

    let res = await createCompanyOffer(offerTitle, offerDescription, offerType, offerValue, offerCode, offerUrl, offerExpiry, offerTerms, howToRedeem);

    if (res.success) {
      setHasOffer(true);
      fetchOfferData();
    }

    else {
      alert('error');
    }
  };

  const handleUpdateOffer = async (e) => {
    e.preventDefault();

    // Handle form submission
    if (offerTitle === "" || offerDescription === "") {
      alert("Please fill in all required fields.");
      return;
    }

    let res = await updateCompanyOffer(offerTitle, offerDescription, offerType, offerValue, offerCode, offerUrl, offerExpiry, offerTerms, howToRedeem);

    if (res.success) {
      setShowSuccessBanner(true);
      // Hide the banner after 3 seconds
      setTimeout(() => {
        setShowSuccessBanner(false);
      }, 3000);
    } else {
      alert('error');
    }
  };

  const handleRemoveOffer = async () => {
    if (window.confirm('Are you sure you want to remove this offer? This action cannot be undone.')) {
      let res = await removeCompanyOffer(offerId);
      if (res.success) {
        setHasOffer(false);
        setOfferTitle("");
        setOfferDescription("");
        setOfferType("discount");
        setOfferValue("");
        setOfferCode("");
        setOfferUrl("");
        setOfferExpiry("");
        setOfferTerms("");
      } else {
        alert('Error removing offer');
      }
    }
  };

  useEffect(() => {
    const fetchOfferData = async () => {
      try {
        let res = await getCompanyOffer();
        if (res.success && res.data != null && res.data.length > 0) {
          let row = res.data[0];
          setOfferId(row.company_offer_id || "");

          setOfferTitle(row.title || "");
          setOfferDescription(row.description || "");
          setOfferType(row.offer_type || "discount");
          setOfferValue(row.offer_value || "");
          setOfferCode(row.offer_code || "");
          setOfferUrl(row.offer_url || "");
          setOfferExpiry(row.expires_on || "");
          setOfferTerms(row.terms_and_conditions || "");
          setHowToRedeem(row.how_to_redeem || "");
          setHasOffer(true);

          setLoading(false);
        }

        else{
          setHasOffer(false);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching offer data:", error);
      }
    }

    fetchOfferData();
  }, []);


  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark">
      <div className="container-custom py-6 px-4 mx-auto">
        <h1 className="text-3xl font-bold text-gray-900">Manage Offers</h1>

        <div className={`mt-6 mb-8 rounded-lg shadow-lg ${
          hasOffer 
            ? 'bg-gradient-to-r from-emerald-600 to-teal-600' 
            : 'bg-gradient-to-r from-purple-600 to-indigo-600'
        }`}>
          <div className="px-6 py-8 text-white">
            <div className="flex items-center space-x-4 mb-4">
              <div className="p-2 bg-white bg-opacity-20 rounded-lg">
                {hasOffer ? <FaIcons.FaCheckCircle className="h-6 w-6" /> : <FaIcons.FaGift className="h-6 w-6" />}
              </div>
              <h2 className="text-xl font-semibold">
                {hasOffer ? 'Active Offer' : 'Why Create Special Offers?'}
              </h2>
            </div>
            <p className="mb-4">
              {hasOffer 
                ? 'You have an active offer that customers can redeem. You can update or remove it at any time.'
                : 'Special offers are a powerful way to attract new customers and increase conversions. They create urgency and give potential customers an extra incentive to try your product.'}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div className="flex items-center space-x-2">
                <FaIcons.FaChartLine className="h-4 w-4" />
                <span>Boost conversion rates</span>
              </div>
              <div className="flex items-center space-x-2">
                <FaIcons.FaUserPlus className="h-4 w-4" />
                <span>Attract new customers</span>
              </div>
              <div className="flex items-center space-x-2">
                <FaIcons.FaClock className="h-4 w-4" />
                <span>Create urgency</span>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
          </div>
        ) : (
          <>

            <div className="justify-between items-center mb-8">
              <div>
                <div className=" items-center gap-4 mb-2">

                  <div className="bg-white rounded-lg border shadow-sm">
                    {showSuccessBanner && (
                      <div className="bg-green-50 p-4 rounded-t-lg border-b border-green-200">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div className="ml-3">
                            <p className="text-sm font-medium text-green-800">
                              Changes saved successfully!
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="p-6">
                      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Offer Title</label>
                          <input
                            type="text"
                            name="title"
                            value={offerTitle}
                            onChange={(e) => setOfferTitle(e.target.value)}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="e.g., Launch Week Special"
                            required
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Offer Code <span className="text-xs font-medium text-gray-400">* Optional</span></label>
                          <input
                            type="text"
                            name="offerCode"
                            value={offerCode}
                            onChange={(e) => setOfferCode(e.target.value)}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="e.g., LAUNCH2024"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Offer URL <span className="text-xs font-medium text-gray-400">* Optional</span></label>
                          <input
                            type="url"
                            name="offerUrl"
                            value={offerUrl}
                            onChange={(e) => setOfferUrl(e.target.value)}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="https://example.com/special-offer"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Offer Description</label>
                          <textarea
                            name="description"
                            value={offerDescription}
                            onChange={(e) => setOfferDescription(e.target.value)}
                            rows={3}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="Describe your offer and its benefits"
                            required
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">How to Redeem</label>
                          <textarea
                            name="termsAndConditions"
                            value={howToRedeem}
                            onChange={(e) => setHowToRedeem(e.target.value)}
                            rows={3}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="Specify any terms, conditions, or restrictions"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Terms and Conditions <span className="text-xs font-medium text-gray-400">* Optional</span></label>
                          <textarea
                            name="termsAndConditions"
                            value={offerTerms}
                            onChange={(e) => setOfferTerms(e.target.value)}
                            rows={3}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="Specify any terms, conditions, or restrictions"
                          />
                        </div>
                      </div>

                      <div className="flex justify-end space-x-3 mt-4">
                        {hasOffer && (
                          <>
                            <button
                              type="button"
                              onClick={handleRemoveOffer}
                              className="px-4 py-2 text-sm text-red-600 border border-red-300 rounded-md hover:bg-red-50"
                            >
                              Remove Offer
                            </button>
                            <button
                              type="button"
                              onClick={(e) => handleUpdateOffer(e)}
                              className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50"
                            >
                              Save Changes
                            </button>
                          </>
                        )}

                        {!hasOffer && (
                          <button
                            type="submit"
                            onClick={(e) => handleSubmitOffer(e)}
                            className="px-4 py-2 text-sm text-white bg-purple-600 rounded-md hover:bg-purple-700"
                          >
                            Create Offer
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Offers;